import repetService from "../services/repet";

const puc = (pucAFIP, nameGroup, entityDocId, indexGroup, uifsro, itemDoc, setField, setEntityTypeIdOwmer, setCantidadCondoApod, cantidadCondoApod, info, data, group, addElementGroup, setEntityPropIdOwner) => {
    try {

        let tipoPersonaafip;

        if (pucAFIP.personaReturn) {
            if (pucAFIP.personaReturn.datosGenerales) {
                tipoPersonaafip = pucAFIP.personaReturn.datosGenerales.tipoPersona;
            }
        }
        let tipoPersona;
        if (tipoPersonaafip === 'FISICA') {
            tipoPersona = {
                id: "1", label: 'Humana', isInactive: '0'
            }
        }
        if (tipoPersonaafip === 'JURIDICA') {
            tipoPersona = {
                id: "2", label: 'Jurídica', isInactive: '0'
            }
        }
        if (entityDocId === '1') {
            setEntityTypeIdOwmer([tipoPersona]);
            setEntityPropIdOwner([{
                id: "1", label: 'Titular', isInactive: '0'
            }]);
        }

        if (Number(itemDoc.id) === 1) {
            if (tipoPersona.id === 2)
                setCantidadCondoApod(cantidadCondoApod - 1);
        }

        let tipoClave;
        info.forEach((item) => {
            if (item.name === pucAFIP.personaReturn.datosGenerales.tipoClave) {
                tipoClave = {
                    id: item.id,
                    label: item.nameAlt !== undefined ? `${item.name} ${item.nameAlt}` : `${item.name}`,
                    isInactive: '0'

                }
            }
        })

        let impuestos = "";
        if (pucAFIP.personaReturn.datosRegimenGeneral) {
            for (let u = 0; u < pucAFIP.personaReturn.datosRegimenGeneral.impuesto.length; u++) {
                impuestos = `${pucAFIP.personaReturn.datosRegimenGeneral.impuesto[u].periodo} ${pucAFIP.personaReturn.datosRegimenGeneral.impuesto[u].descripcionImpuesto}, ${impuestos}`;
            }
        }
        let actividadAFIP = [];
        let actividades = "";
        if (pucAFIP.personaReturn.datosRegimenGeneral) {
            for (let u = 0; u < pucAFIP.personaReturn.datosRegimenGeneral.actividad.length; u++) {
                actividades = `${pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].idActividad} | ${pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].descripcionActividad} ${actividades}`
                info.forEach((item) => {
                    if (Number(item.name) === Number(pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].idActividad)) {
                        actividadAFIP.push({
                            order: pucAFIP.personaReturn.datosRegimenGeneral.actividad[u].orden,
                            actividad: {
                                id: item.id,
                                label: item.nameAlt !== undefined ? `${item.name} ${item.nameAlt}` : `${item.name}`,
                                isInactive: '0'

                            }
                        });
                    }
                })
            }
        }
        let dni = '';
        let tipoDocDni;
        if (pucAFIP.personaReturn.datosGenerales.idPersona.toString().substring(0, 1) !== '3') {
            dni = pucAFIP.personaReturn.datosGenerales.idPersona.toString().substring(2, Number(pucAFIP.personaReturn.datosGenerales.idPersona.toString().length) - 1);
            tipoDocDni = {
                id: "37",
                label: 'DNI',
                isInactive: '0'

            }
        }

        let monotributo;
        if (pucAFIP.personaReturn.datosMonotributo) {
            if (pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo) {
                monotributo = {
                    id: "6",
                    label: 'Responsable Monotributo',
                    isInactive: '0'
                }
            }
        }
        let isAutonomo = false;
        if (pucAFIP.personaReturn.datosRegimenGeneral)
            if (pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo)
                isAutonomo = true;

        if (nameGroup === null) {

            data.forEach((itemData) => {
                if (itemData.id === itemDoc.id) {
                    itemData.boxes.forEach((itemBoxs) => {
                        itemBoxs.fields.forEach((item) => {

                            if (item.group === null) {

                                let idField = `${itemDoc.entityDocId}_${itemDoc.id}_${item.id}`;
                                fieldsSet(item.idFieldTable, idField, setField, pucAFIP, monotributo, isAutonomo, actividadAFIP, tipoDocDni, tipoPersonaafip, impuestos, actividades, tipoPersona, tipoClave, dni, uifsro);

                            } else {

                                item.group.forEach((item) => {
                                    let nameGroup = `${itemDoc.entityDocId}_${itemDoc.id}_${item.name}`;

                                    if (group[nameGroup]) {
                                        for (let y = 0; y < group[nameGroup].length; y++) {
                                            for (let i = 0; i < group[nameGroup][y].fields.length; i++) {

                                            }
                                        }
                                    }
                                })

                            }

                        })
                    })
                }
            })
        } else {
            for (let y = 0; y < group[nameGroup].length; y++) {
                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                    if (y === indexGroup) {
                        let id = group[nameGroup][y].fields[i].id;
                        if (group[nameGroup][y].fields[i].id.split('_').length === 1)
                            id = `${itemDoc.entityDocId}_${itemDoc.id}_${group[nameGroup][y].fields[i].id}`

                        fieldsSet(group[nameGroup][y].fields[i].idFieldTable, id, setField, pucAFIP, monotributo, isAutonomo, actividadAFIP, tipoDocDni, tipoPersonaafip, impuestos, actividades, tipoPersona, tipoClave, dni, uifsro)
                    }
                }
            }
        }
        //}
    } catch (error) {
        console.log('erro-> ' + error)
    }
}

const fieldsSet = (idFieldTable, id, setField, pucAFIP, monotributo, isAutonomo, actividadAFIP, tipoDocDni, tipoPersonaafip, impuestos, actividades, tipoPersona, tipoClave, dni, uifsro) => {
    switch (idFieldTable) {
        case 'argAfipVatConditionId':
            if (monotributo)
                setField(prevState => ({
                    ...prevState,
                    [id]: monotributo
                }), []);
            break;
        case 'argCategoriaMonotributo':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo.descripcionCategoria}` : '',
            }), []);
            break;
        case 'isAutonomo':
            setField(prevState => ({
                ...prevState,
                [id]: isAutonomo
            }), []);
            break;
        case 'argCategoriaAutonomo':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosRegimenGeneral != null ? pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo : '',
            }), []);
            break;
        case 'argAfipNaesId':
            for (let e = 0; e < actividadAFIP.length; e++) {
                if (e === 0) {
                    setField(prevState => ({
                        ...prevState,
                        [id]: actividadAFIP[e].actividad
                    }), []);
                }
            }
            break;
        case 'order':
            for (let e = 0; e < actividadAFIP.length; e++) {
                if (e === 0) {
                    setField(prevState => ({
                        ...prevState,
                        [id]: actividadAFIP[e].order
                    }), []);
                }
            }
            break;
        case 'argAfipPinTypeId':
            if (tipoDocDni)
                setField(prevState => ({
                    ...prevState,
                    [id]: tipoDocDni
                }), []);
            break;
        case 'firstName':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.nombre
            }), []);
            break;
        case 'argAfipNombre':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.nombre
            }), []);
            break;
        case 'lastName':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.apellido,
            }), []);
            break;
        case 'argAfipApellido':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.apellido
            }), []);
            break;
        case 'name':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
            }), []);
            break;
        case 'fullName':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
            }), []);
            break;
        case 'beneficiary':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.razonSocial == null ? `${pucAFIP.personaReturn.datosGenerales.apellido}, ${pucAFIP.personaReturn.datosGenerales.nombre}` : pucAFIP.personaReturn.datosGenerales.razonSocial,
            }), []);
            break;
        case 'argAfipEstadoClave':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.estadoClave,
            }), []);
            break;
        case 'argAfipTipoPersona':
            setField(prevState => ({
                ...prevState,
                [id]: tipoPersonaafip
            }), []);
            break;
        case 'argAfipRazonSocial':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.razonSocial,
            }), []);
            break;
        case 'argAfipDomicilio':
            setField(prevState => ({
                ...prevState,
                [id]: `${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.tipoDomicilio} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.direccion} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.codPostal} ${pucAFIP.personaReturn.datosGenerales.domicilioFiscal.descripcionProvincia}`,
            }), []);
            break;
        case 'argAfipImpuesto':
            setField(prevState => ({
                ...prevState,
                [id]: impuestos
            }), []);
            break;
        case 'argAfipCategoriaAutonomo':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosRegimenGeneral != null ? pucAFIP.personaReturn.datosRegimenGeneral.categoriaAutonomo : '',
            }), []);
            break;
        case 'argAfipActividad':
            setField(prevState => ({
                ...prevState,
                [id]: actividades
            }), []);
            break;
        case 'argAfipActividadMonotributista':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.actividadMonotributista.descripcionActividad}` : '',
            }), []);
            break;
        case 'argAfipCategoriaMonotributo':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosMonotributo != null ? `${pucAFIP.personaReturn.datosMonotributo.categoriaMonotributo.descripcionCategoria}` : '',
            }), []);
            break;
        case 'argAfipFechaContratoSocial':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.fechaContratoSocial,
            }), []);
            break;
        case 'entityTypeId':
          
            setField(prevState => ({
                ...prevState,
                [id]: tipoPersona
            }), []);
            break;
        case 'argAfipTinTypeId':
            setField(prevState => ({
                ...prevState,
                [id]: tipoClave
            }), []);
            break;
        case 'legalName':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.razonSocial,
            }), []);
            break;
        case 'argTin':
            setField(prevState => ({
                ...prevState,
                [id]: pucAFIP.personaReturn.datosGenerales.idPersona,
            }), []);
            break;
        case 'argPin':
            setField(prevState => ({
                ...prevState,
                [id]: dni,
            }), []);
            break;
        case 'argUifSRO':
            if (uifsro) {

                setField(prevState => ({
                    ...prevState,
                    [id]: uifsro
                }), []);
            }

            break;
        case 'argAfipPUC':
            if (tipoDocDni)
                setField(prevState => ({
                    ...prevState,
                    [id]: pucAFIP
                }), []);
            break;
        case 'argRePET':

            if (tipoPersona.id === 1) {
                repetService.viewrepetpersonas.then((response) => {
                    let responseRepet = response.data;

                    let name = pucAFIP.personaReturn.datosGenerales.nombre;
                    let apellido = pucAFIP.personaReturn.datosGenerales.apellido;
                    let existe = false;
                    for (let r = 0; r < responseRepet.length; r++) {
                        if ((name === responseRepet[r].FIRST_NAME || name === responseRepet[r].SECOND_NAME || name === responseRepet[r].THIRD_NAME || name === responseRepet[r].FOURTH_NAME) &&
                            (apellido === responseRepet[r].FIRST_NAME || apellido === responseRepet[r].SECOND_NAME || apellido === responseRepet[r].THIRD_NAME || apellido === responseRepet[r].FOURTH_NAME)) {
                            existe = true;
                            responseRepet[r].Ejecución = new Date();
                            setField(prevState => ({
                                ...prevState,
                                [id]: responseRepet[r],
                            }), []);
                        }
                    }
                    if (!existe) {
                        setField(prevState => ({
                            ...prevState,
                            [id]: { 'mensaje': 'No hay coincidencias', 'Ejecución': new Date() }
                        }), []);
                    }
                }).catch((error) => {
                    console.log(error);
                });
            } else {
                repetService.viewrepetentidadaes.then((response) => {
                    let responseRepet = response.data;
                    let razonSocial = pucAFIP.personaReturn.datosGenerales.razonSocial;
                    let existe = false;
                    for (let r = 0; r < responseRepet.length; r++) {
                        if (razonSocial === responseRepet[r].FIRST_NAME) {
                            existe = true;
                            responseRepet[r].Ejecución = new Date();
                            setField(prevState => ({
                                ...prevState,
                                [id]: responseRepet[r],
                            }), []);
                        }
                    }
                    if (!existe) {
                        setField(prevState => ({
                            ...prevState,
                            [id]: { 'mensaje': 'No hay coincidencias', 'Ejecución': new Date() }
                        }), []);
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }

            break;
        default:
            break;
    }

}


export default puc;